export default __webpack_public_path__ + "static/media/ESSK34EMER01_1920x1080.a6de3b9a.jpg";